import { useState, useEffect} from "react";
// Opciones del menu
import RegistroHoras from "./registroHorasForm";
import TablaColaboradores from "./aprobacionDepartamentoForm";
import AprobacionHorasSupervisor from "./aprobacionSupervisorForm";
import AsignacionCostoHora from "./asignacionCostoHoraForm";
import ReportesFinanzas from "./reportesFinanzas";
import CrudProyectos from "./administrador/proyectos";
import ListGroup from "react-bootstrap/ListGroup";
import BarraNavegacion from "./BarraNavegacion";
import PiePagina from "./piePagina";
import DiasAsuetoForm from "./diasAsuetoForm";
import EtapasForm from "./etapasForm";
import TareasForm from "./tareasForm";
import UsuariosForm from "./usuariosForm";
import Anuncios from "./anuncios";
import ReporteOmisionesForm from "./reporteOmisionesForm";
//
import axios from "axios";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function Contenido({userParam, cerrarSesionParam, apiUrl, selectedOption, setSelectedOption, selectedContent, setSelectedContent}) {
  const [menuEstructura, setMenuEstructura] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const obtenMenuEstructura = ()=> {
    if(userParam !== undefined && userParam !== null) {
      axios.post(`${apiUrl}/usuario/obtenMenuEstructura`, 
        {idPerfil: userParam.idPerfil})
        .then((objResponse) => {
          setMenuEstructura(objResponse.data.response.MenuEstructura);
        })
        .catch((error) => {
          alert('hubo un error: ' + error.response.data)
        });
    }
  }

  useEffect(()=>{
    obtenMenuEstructura()
  },[userParam])

  useEffect(() => {
    switch (selectedOption) {
      case "registro_horas":
        setSelectedContent(<RegistroHoras usuario={userParam} apiUrl={apiUrl}></RegistroHoras>);
        break;
      case "aprobacion_horas_supervisor":
        setSelectedContent(<AprobacionHorasSupervisor usuario={userParam} apiUrl={apiUrl}></AprobacionHorasSupervisor>);
        break;
        case "aprobacion_horas":
        setSelectedContent(<TablaColaboradores usuario={userParam} apiUrl={apiUrl}></TablaColaboradores>);
        break;
      case "asignacion_costo_hora":
        setSelectedContent(<AsignacionCostoHora usuario={userParam} apiUrl={apiUrl}></AsignacionCostoHora>);
        break;
      case "reportes_finanzas":
        setSelectedContent(<ReportesFinanzas usuario={userParam} apiUrl={apiUrl}></ReportesFinanzas>);
        break;
      case "proyectos":
        setSelectedContent(<CrudProyectos usuario={userParam} apiUrl={apiUrl}></CrudProyectos>)
        break;
      case "diasAsueto":
        setSelectedContent(<DiasAsuetoForm usuario={userParam} apiUrl={apiUrl}></DiasAsuetoForm>)
        break;
      case "etapas":
        setSelectedContent(<EtapasForm usuario={userParam} apiUrl={apiUrl}></EtapasForm>)
        break;
      case "tareas":
        setSelectedContent(<TareasForm usuario={userParam} apiUrl={apiUrl}></TareasForm>)
        break;
      case "usuarios":
        setSelectedContent(<UsuariosForm usuario={userParam} apiUrl={apiUrl}></UsuariosForm>)
        break;
      case "reporte_omisiones":
        setSelectedContent(<ReporteOmisionesForm usuario={userParam} apiUrl={apiUrl}></ReporteOmisionesForm>)
        break;
      case "cerrarSesion":
        setSelectedContent(null)
        break;
      default:
        setSelectedContent(<Anuncios></Anuncios>)
    }
  }, [selectedOption])

  return (
    <div className="d-flex flex-column min-vh-100">
      <BarraNavegacion 
        handleShowMenu={handleShow}
      />
      <Offcanvas show={show} onHide={handleClose} placement="start" >
        <Offcanvas.Header >
          <Row className="text-center">
            <Col className='align-items-center'>
              <Image width={'30%'} src={userParam.UrlPhoto} roundedCircle className="d-block mx-auto"/>
              <label>¡Bienvenido, <b>{userParam.NOMBREUSUARIO}</b>!</label>
            </Col>
          </Row>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ListGroup variant="flush" onSelect={(selectedKey) => (setSelectedOption(selectedKey))}>
            {
              (menuEstructura!==undefined) ?
                menuEstructura.map(menu =>
                    <ListGroup.Item
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        borderRadius: '4px',
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f0f0f0'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                      key={'btn_menu'+menu.idMenuEstructura} 
                      eventKey={menu.menuEstructuraNombre}
                      action 
                    >{menu.menuEstructuraDes}</ListGroup.Item>
                )
                : ""
              }
              <ListGroup.Item
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={()=>{cerrarSesionParam(); }}
                onSelect={(selectedKey) => (setSelectedOption("cerrarSesion"))}
                action 
              >Cerrar sesión</ListGroup.Item>
          </ListGroup>
        </Offcanvas.Body>
      </Offcanvas>
      <div className="flex-grow-1">
        {selectedContent}
      </div>
      <PiePagina/>
    </div>
  );
}

export default Contenido;
